module.exports = __webpack_public_path__ + "img/how-to_image06.09b5dc12.png";